import React, { useEffect, useState } from 'react';
import { FormControlLabel, Switch, Tooltip } from '@mui/material';
import { useLang } from '~/hooks/useLang';

interface FilterSwitchProps {
    readonly label: string;
    readonly onCheckedChange: (value: boolean) => void;
    readonly checked: boolean;
    readonly disabled?: boolean
    readonly tooltip?: string | null
    readonly size?: 'small' | 'medium'  // Adicionado para suportar tamanho
}

export default function FilterSwitch({ label, onCheckedChange, checked, disabled, tooltip, size }: FilterSwitchProps) {
    const { translate } = useLang();
    const [isChecked, setIsChecked] = useState<boolean>(false);

    useEffect(() => {
        setIsChecked(checked)
    }, [checked])


    return (
        <FormControlLabel
            label={translate(label)}
            sx={{
                '& .MuiFormControlLabel-label': {
                    fontSize: size === 'small' ? '0.75rem' : '1rem',  // Aplica redução apenas se size for 'small'
                },
            }}
            control={
                <Tooltip title={tooltip ? translate(tooltip) : translate(label)}>
                    <Switch
                        disabled={disabled}
                        checked={isChecked}
                        onChange={(_, checked) => {
                            setIsChecked(checked)
                            onCheckedChange(checked)
                        }}
                        size={size}
                    />
                </Tooltip>
            }
        />
    )
}